import script from "./MarketPlace.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketPlace.vue?vue&type=script&setup=true&lang=js"

import "./MarketPlace.vue?vue&type=style&index=0&id=3f86b6e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f86b6e8"]])

export default __exports__